import Slider from '@src/components/slider';

class FactsSlider {
  constructor() {
    this.factsSlider = null;
    this.init();
  }

  init() {
    this.factsSlider = new Slider({
      container: '.js-facts-slider',
      navContainer: '.js-facts-slider-nav',
      loop: false,
      mode: 'gallery',
      controls: false,
    });
  }
}

export default FactsSlider;
